import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
// import Modal from "react-modal";

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    border: 'none',
    padding: '0',
  },
};
// Modal.setAppElement(document.getElementsByClassName('brands-countries-popup'));

const OurBrandsCountries = (props) => {
  const language = drupalSettings.path.currentLanguage || '';
  const translations = {
    franchise: Drupal.t('Franchise'),
    countries: Drupal.t('Select country'),
    all_countries: Drupal.t('All countries'),
    visit_website: Drupal.t('Visit website'),
    contact_us: Drupal.t('Contact us'),
  };
  // const redirectUrl = document.getElementsByClassName('brands-countries-popup')[0].getAttribute('data-contact');
  const [allBrands, setAllBrands] = useState([]);
  const [countries, setCountries] = useState([]);
  const [allBrandsCountries, setAllBrandsCountries] = useState([]);
  const [selectedCountryId, setSelectedCountryId] = useState(0);
  const [selectedBrandIndex, setSelectedBrandIndex] = useState(props.brandId.id);
  const [selectedBrandCountryData, setSelectedBrandCountryData] = useState(null);
  const [label, setLabel] = useState(<></>);

  // Parse excluded countries IDs from props
  const excludedCountriesIds = props.excludedCountries 
    ? props.excludedCountries.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id))
    : [];

  useEffect(() => {
    getBrandsAndCountries();
  }, []);

  function getBrandsAndCountries() {

    const brandsUrl = '/' + language + '/api/taxonomy/brands';
    const countriesUrl = '/' + language + '/api/taxonomy/countries';
    const brandsCountriesUrl = '/' + language + '/api/taxonomy/brands_in_countries';

    let brands;
    let countries;
    let brandsCountries;

    const brandsRequest = axios.get(brandsUrl);
    const countriesRequest = axios.get(countriesUrl);
    const brandsCountriesRequest = axios.get(brandsCountriesUrl);

    axios.all([brandsRequest, countriesRequest, brandsCountriesRequest]).then(axios.spread((...responses) => {
      brands = responses[0].data;
      countries = responses[1].data;
      brandsCountries = responses[2].data;
      
      // Filter out excluded brands_in_countries
      if (excludedCountriesIds.length > 0) {
        brandsCountries = brandsCountries.filter(item => {
          return !excludedCountriesIds.includes(parseInt(item.id)); // id are stored as strings
        });
      }
      
      setAllBrands(brands);
      setCountries(countries);
      setAllBrandsCountries(brandsCountries);
    })).catch(errors => {
      console.error(errors);
    });
  }

  function createCountryOptions(countries) {
    // let countriesPlaceholder = translations.countries;
    // if (!allBrandsCountries.length > 0) {
    //   return <option value="" disabled key='selectCountry' selected>{{ countriesPlaceholder }}</option>;
    // }
    let filteredCountriesBrands = [];
    for (let b = 0; b < allBrandsCountries.length; b++) {
      if (allBrandsCountries[b].field_brand[0]['target_id'] == selectedBrandIndex) {
        filteredCountriesBrands.push(allBrandsCountries[b]);
      }
    }
    let options = [];
    options.push(<option value='0'
                         key='0'>{translations.countries}</option>);
    for (let c = 0; c < filteredCountriesBrands.length; c++) {
      let country = countries.filter(el => {
        return el.id === filteredCountriesBrands[c].field_country[0].target_id;
      })[0];
      options.push(<option value={country.id}
                           key={'country' + (c)}>{country.name}</option>);
    }
    // console.log(options)
    return options;
  }

  function handleChangeCountry(event) {
    let countryId = event.target.value;
    if(countryId != 0) {
      setLabel(<label>{translations.countries}</label>)
    }
    else {
      setLabel(<></>)
    }
    setSelectedCountryId(countryId);

    let brandCountry;
    brandCountry = allBrandsCountries.filter(element => {
      return element.field_brand[0].target_id === selectedBrandIndex && element.field_country[0].target_id === countryId;
    })[0];
    setSelectedBrandCountryData(brandCountry);
  }

  // function createHeader() {
  //     let brand = allBrands.filter(el => {
  //         return el.id === selectedBrandIndex //&& el.field_popup_title[0] && el.field_popup_image[0] && el.field_popup_image_mobile[0]
  //     })[0];
  //
  //     return ( brand ? (<div className="row">
  //         <div className="col-12">
  //             <img className="img-fluid desktop" src={brand.field_popup_image[0].url} alt={brand.field_popup_image[0].alt} width={brand.field_popup_image[0].width} height={brand.field_popup_image[0].height}/>
  //             <img className="img-fluid mobile" src={brand.field_popup_image_mobile[0].url} alt={brand.field_popup_image_mobile[0].alt} width={brand.field_popup_image_mobile[0].width} height={brand.field_popup_image_mobile[0].height}/>
  //         </div>
  //         <div className="col-12">
  //             <div className="name text-center">{brand.name}</div>
  //         </div>
  //         <div className="col-12">
  //             <div className="popup-title text-center">{brand.field_popup_title[0].value}</div>
  //         </div>
  //         <div className="col-12">
  //             <div className="grey-border-bottom"></div>
  //         </div>
  //     </div>) : null);
  // }

  function createButton() {
    let brandCountry;
    if (selectedBrandCountryData && selectedBrandCountryData.field_website[0]) {
      brandCountry = selectedBrandCountryData;
    }

    return brandCountry ? <a className="btn btn-outline-primary btn-gray-text active" target="_blank"
              href={brandCountry.field_our_brands_franchise_url[0]['uri']}>{translations.visit_website}</a> : <a className="btn btn-outline-primary active" target="_blank"
                                                                                                href="#">{translations.visit_website}</a>;
  }

    return (
      <>

        <div className="d-flex flex-wrap justify-content-center">
          <div className="col-sm-4 col-6">
            <div className="form--select-wrapper">
              {label}
            <select className="form-control w-100"
                    onChange={handleChangeCountry}
                    value={selectedCountryId}
            >
              {createCountryOptions(countries)}
            </select>
            </div>
          </div>
          <div className="col-sm-4 col-6">
            {createButton()}
          </div>
        </div>

      </>
    );
  };


  export default OurBrandsCountries;
